import { Directive, ElementRef, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';

/**
 * Structural-ish attribute directive that mirrors the `.reveal` / `.is-visible`
 * CSS classes used throughout the site. Apply alongside class="reveal":
 *
 *   <div class="reveal" appReveal>...</div>
 *
 * Once the host element scrolls into view, `is-visible` is added and the
 * observer disconnects (matches the one-shot behavior of the original
 * vanilla-JS implementation).
 */
@Directive({
  selector: '[appReveal]',
  standalone: true,
})
export class RevealDirective implements AfterViewInit, OnDestroy {
  private observer?: IntersectionObserver;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    if (!('IntersectionObserver' in window)) {
      this.renderer.addClass(this.el.nativeElement, 'is-visible');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.renderer.addClass(this.el.nativeElement, 'is-visible');
            this.observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
